import { Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Toast from '../../Components/Toast';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getItem } from '../../Services/localService';
import { Eraser, Palette, Trash } from 'lucide-react';

const SetSectionModal = ({ show, handleClose, handleSave, selectedOption,
    setSelectedOption, selectedModuleName, previousSection, url, setUrl, color, setColor }) => {
    let formList = useSelector((state) => state?.forms);
    let sidebarSectionData = useSelector((state) => state?.sidebar);

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    let [loader, setLoader] = useState(false);
    let [showColorPicker, setShowColorPicker] = useState(false);

    const options = sidebarSectionData?.sectionData?.map(item => ({
        value: item.section_name,
        label: item.section_name
    }));
    // const options = [
    //     { value: "Dashboard", label: "Dashboard" },
    //     { value: "Sales", label: "Sales" },
    //     { value: "Activities", label: "Activities" },
    //     { value: "O2C", label: "O2C" },
    //     { value: "Services", label: "Services" },
    //     { value: "Master", label: "Master" }
    // ];

    useEffect(() => {
        if (previousSection) {
            const defaultOption = options.find(
                (opt) => opt.value === previousSection
            );
            setSelectedOption(defaultOption || null);
        } else {
            setSelectedOption(null);
        }
    }, []);

    const handleChange = (option) => {
        setSelectedOption(option);
    };

    const headers = (isMultipart = false) => {
        const header = {
            Authorization: `Bearer ${getItem("token")}`,
            "Content-Type": "application/json",
        }
        if (isMultipart) {
            header['Content-Type'] = 'multipart/form-data'
        }
        return header
    };

    let handleInputChange = async (e) => {
        setLoader(true);
        const file = e.target.files?.[0];
        if (!file) { setUrl(''); setColor(''); setLoader(false); return };
        if (file) {
            try {
                // Create form data
                const formData = new FormData();
                formData.append("file", file);
                const res = await axios.post(`${BACKEND_URL}/form-sub-module/upload-form-img-file`, formData, { headers: headers(true) });
                if (res?.data?.success && res?.data?.s3Url) {
                    setLoader(false);
                    setUrl(res?.data?.s3Url);
                }
            } catch (err) {
                setLoader(false);
                console.error("File upload error:", err);
                toast.error(err?.response?.statusText, {
                    autoClose: 2000,
                })
            }
        }
    }

    return (
        <>
            <Toast />
            <Modal show={show} onHide={handleClose} backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Add "{selectedModuleName}" to Sidebar Section</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '270px' }}>
                    {loader ?
                        <div className="section-modal-loader">
                            <Spinner animation="border" variant="primary" center />
                        </div>
                        :
                        <>
                            <label className="form-label">Select section to show "{selectedModuleName}" module in sidebar</label>
                            <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="Select section"
                                isClearable
                            />

                            <label className="form-label mt-2">Upload Icon</label>
                            <input
                                className="form-control"
                                type="file"
                                accept=".svg,image/svg+xml"
                                onChange={handleInputChange}
                            />

                            {url &&
                                <>
                                    <div className="d-flex align-items-center mt-2">
                                        <label className="form-label">Uploaded Icon</label>
                                        <img src={url} alt="icon" className="ms-3" />
                                        <div className="ms-auto d-flex gap-2">
                                            <Trash size={14} className="cursor-pointer" title="Remove icon" onClick={() => { setUrl(''); setColor('') }} />
                                            <Palette size={14} className="cursor-pointer" title="Change icon color" onClick={() => setShowColorPicker(!showColorPicker)} />
                                            {/* <span class="fw-semibold ms-3 cursor-pointer" title="Remove icon" onClick={() => { setUrl(''); setColor('') }}>x</span> */}
                                        </div>
                                    </div>
                                    {showColorPicker &&
                                        <div className="d-flex align-items-center">
                                            <label className="form-label mt-2">Change Icon Color</label>
                                            <div
                                                className="ms-3 me-3"
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: color || '#000000',
                                                    maskImage: `url(${url})`,
                                                    WebkitMaskImage: `url(${url})`,
                                                    maskRepeat: "no-repeat",
                                                    WebkitMaskRepeat: "no-repeat",
                                                    maskSize: "contain",
                                                    WebkitMaskSize: "contain"
                                                }}
                                            />
                                            <input
                                                type="color"
                                                value={color}
                                                onChange={(e) => setColor(e.target.value)}
                                                style={{
                                                    width: 30,
                                                    height: 20,
                                                    backgroundColor: color,
                                                    border: `1px solid ${color}`,
                                                    borderRadius: 6,
                                                    cursor: "pointer",
                                                    display: "block",
                                                    padding: 0,
                                                }}
                                            />
                                            <div className="ms-auto d-flex gap-2">
                                                <Eraser size={14} className="cursor-pointer" title="Revert" onClick={() => { setColor(''); setShowColorPicker(false) }} />
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave} disabled={!selectedOption || !url}>
                        Save
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default SetSectionModal;